// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3uBFx","errors":"Errors_errors__rFCYg"};